import { isCallable } from './isCallable';
export function isPromise(val) {
    return typeof val === 'object' && val !== null && 'then' in val && isCallable(val.then);
}
